'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgChatHelpCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M0 6c0 1.177.338 2.311.98 3.287-.21.238-.391.403-.54.498a.732.732 0 00.11 1.292c.248.105.562.167.94.167.391 0 .814-.068 1.26-.2C3.718 11.67 4.841 12 6 12c3.31 0 6-2.69 6-6S9.31 0 6 0 0 2.69 0 6zm2.134 2.698A4.687 4.687 0 011.286 6 4.72 4.72 0 016 1.286 4.72 4.72 0 0110.714 6 4.72 4.72 0 016 10.714c-.94 0-1.847-.275-2.623-.798a1.286 1.286 0 00-1.05-.173 1.28 1.28 0 00-.193-1.045zm3.876-1.59c.39 0 .705.266.705.643 0 .383-.315.65-.705.65-.39 0-.705-.274-.705-.65 0-.377.308-.644.705-.644zM6.003 3c.384 0 .658.26.65.623l-.088 2.389c-.014.356-.212.548-.555.548-.356 0-.554-.192-.568-.548l-.082-2.39C5.346 3.254 5.613 3 6.003 3z", id: "Chat-help-circle__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Chat-help-circle__svg__a" })))));
}

module.exports = SvgChatHelpCircle;
//# sourceMappingURL=ChatHelpCircle.js.map
